import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

function matchListRef(competitionId) {
  return doc(db, "competitions", competitionId, "projections", "matchList");
}

function activeHoldsRef(competitionId) {
  return doc(db, "competitions", competitionId, "projections", "activeHolds");
}

/** @type {import('./projectionRepository.interface').ProjectionRepository} */
export const firestoreProjectionRepository = {
  async getMatchList(competitionId) {
    const snap = await getDoc(matchListRef(competitionId));
    return snap.exists()
      ? /** @type {import('../../domain/cmoe/projection/projectionLogic').MatchListProjection} */ (snap.data())
      : null;
  },
  async saveMatchList(competitionId, projection) {
    await setDoc(matchListRef(competitionId), projection, { merge: true });
  },
  async getActiveHolds(competitionId) {
    const snap = await getDoc(activeHoldsRef(competitionId));
    return snap.exists()
      ? /** @type {import('../../domain/cmoe/projection/projectionLogic').ActiveHoldsProjection} */ (snap.data())
      : null;
  },
  async saveActiveHolds(competitionId, projection) {
    await setDoc(activeHoldsRef(competitionId), projection, { merge: true });
  },
};
